import type { IconSvgObject } from './types';

const Mouse11Icon: IconSvgObject = [
  ["path", { d: "M12 5.5V2M12 12V9", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 22C18 22 19.5 17.49 19.5 12C19.5 6.50998 18 2 12 2C5.99993 2 4.5 6.50996 4.5 12C4.5 17.49 5.99993 22 12 22Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12.5 5.5H11.5C10.9477 5.5 10.5 5.94772 10.5 6.5V8C10.5 8.55228 10.9477 9 11.5 9H12.5C13.0523 9 13.5 8.55228 13.5 8V6.5C13.5 5.94772 13.0523 5.5 12.5 5.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M5 12H19", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Mouse11Icon;
